import { motion } from "framer-motion";
import { MaskedReveal, FadeUp } from "./MaskedReveal";

const CHAPTERS = [
  {
    n: "01",
    title: "We prevent, not react.",
    body: "Most IT problems announce themselves days before they hit. Our monitoring catches the whisper before it becomes a fire — so the incidents your competitors fight, you simply never have.",
  },
  {
    n: "02",
    title: "Security is the default.",
    body: "Every network we touch is hardened from day one. Zero-trust access, encrypted everywhere, and continuously tested. Compliance stops being a scramble and becomes a byproduct.",
  },
  {
    n: "03",
    title: "One partner, full stack.",
    body: "From the boardroom strategy to the cable in the wall, you get a single accountable team. No hand-offs, no blame, no waiting on a vendor to call you back.",
  },
  {
    n: "04",
    title: "Humans answer the phone.",
    body: "Behind the automation are engineers who know your name and your network. Real people, real fast — the kind of support that makes technology feel invisible.",
  },
];

export const Manifesto = () => {
  return (
    <section
      id="approach"
      data-testid="manifesto-section"
      className="relative bg-[#050505] py-24 md:py-32 border-t border-white/10"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="mb-20 max-w-2xl">
          <p className="text-xs uppercase tracking-[0.28em] text-[#00E5FF] font-bold mb-6">
            Our approach
          </p>
          <MaskedReveal
            as="h2"
            testId="manifesto-heading"
            lines={["Four principles that", "keep you running."]}
            className="text-4xl md:text-5xl lg:text-6xl font-black tracking-tighter text-white leading-[0.95]"
          />
        </div>

        <div className="divide-y divide-white/10 border-t border-white/10">
          {CHAPTERS.map((c, i) => (
            <FadeUp
              key={c.n}
              delay={i * 0.05}
              testId={`manifesto-chapter-${c.n}`}
              className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 py-12 md:py-16 group"
            >
              <div className="md:col-span-4">
                <span className="text-7xl md:text-8xl font-black tracking-tighter text-white/10 transition-colors duration-500 group-hover:text-[#00E5FF]/30">
                  {c.n}
                </span>
              </div>
              <div className="md:col-span-8 md:pt-4">
                <h3 className="text-2xl md:text-4xl font-bold tracking-tight text-white mb-4">
                  {c.title}
                </h3>
                <p className="text-[#A0AEC0] text-base md:text-lg leading-relaxed max-w-2xl">
                  {c.body}
                </p>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
};
